module.exports = __webpack_public_path__ + "static/media/activity.643692e0.png";